import React, { createContext, useState, useContext, useEffect } from 'react';
import { apiClient } from '@/lib/apiClient';


const PricingContext = createContext(null);

export const usePricing = () => {
  const context = useContext(PricingContext);
  if (!context) {
    throw new Error('usePricing must be used within a PricingProvider');
  }
  return context;
};

/**
 * Минимальная цена подписки в месяц, опирается на данные со страницы подписки (API /subscription/pricing).
 * priceFrom имеет вид "699₽/мес".
 */
export const PricingProvider = ({ children }) => {
  const [pricing, setPricing] = useState(() => {
    try {
      const raw = localStorage.getItem('subscription_pricing_cache');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [priceFrom, setPriceFrom] = useState(() => {
    try {
      const raw = localStorage.getItem('subscription_pricing_cache');
      if (!raw) return null;
      const data = JSON.parse(raw);
      const minRub = data?.min_monthly_rub
        ?? (Array.isArray(data?.student_plans)
          ? Math.min(...data.student_plans.map((p) => p.price_monthly).filter((n) => n > 0))
          : null);
      return minRub != null ? `${minRub}₽/мес` : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get(`/subscription/pricing`)
      .then((res) => {
        if (cancelled) return;
        const data = res.data;
        setPricing(data);
        const minRub = data?.min_monthly_rub
        ?? (Array.isArray(data?.student_plans)
          ? Math.min(...data.student_plans.map((p) => p.price_monthly).filter((n) => n > 0))
          : null);
        setPriceFrom(minRub != null ? `${minRub}₽/мес` : null);
        try {
          localStorage.setItem('subscription_pricing_cache', JSON.stringify(data));
        } catch {}
      })
      .catch(() => {
        if (!cancelled) setPriceFrom(null);
      });
    return () => { cancelled = true; };
  }, []);

  const value = {
    pricing,
    /** Строка вида "699₽/мес" (минимальный тариф) или null до загрузки */
    priceFrom,
  };

  return (
    <PricingContext.Provider value={value}>
      {children}
    </PricingContext.Provider>
  );
};
